import api from "./api";

export const getGarageVehicles = async (params = {}) => {
  try {
    const body = {
      party_uuid: params.party_uuid,
      page: params.page || 1,
      page_size: params.page_size || 20,
      order_by: ["created_at"],
      order_direction: params.order_direction || ["DESC"],
      filters: params.filters || {},
    };

    // Add search if provided
    if (params.search) {
      body.search = params.search;
    }

    const response = await api.post("/v1/tenant/garage/list", body);
    return response.data;
  } catch (error) {
    console.error("Error fetching garage vehicles:", error);
    throw error;
  }
};

export const getGarageMakes = async (partyUuid, search = null) => {
  try {
    const body = {
      party_uuid: partyUuid,
    };
    
    // Add search if provided
    if (search) {
      body.search = search;
    }

    const response = await api.post("/v1/tenant/garage/make/list_filter", body);
    return response.data;
  } catch (error) {
    console.error("Error fetching garage makes:", error);
    throw error;
  }
};

export const getGarageModels = async (partyUuid, search = null) => {
  try {
    const body = {
      party_uuid: partyUuid,
    };
    
    // Add search if provided
    if (search) {
      body.search = search;
    }

    const response = await api.post("/v1/tenant/garage/model/list_filter", body);
    return response.data;
  } catch (error) {
    console.error("Error fetching garage models:", error);
    throw error;
  }
};

export const getGarageYears = async (partyUuid, search = null) => {
  try {
    const body = {
      party_uuid: partyUuid,
    };
    
    // Add search if provided
    if (search) {
      body.search = search;
    }

    const response = await api.post("/v1/tenant/garage/year/list_filter", body);
    return response.data;
  } catch (error) {
    console.error("Error fetching garage years:", error);
    throw error;
  }
};

